// @flow
import React, { Component } from 'react';
import { Portal } from 'react-portal';
import closeIcon from '../../../static/images/close_bt_white.svg';

import '../../../static/scss/components/modal.scss';

type Props = {
  children?: string | Array<any> | any,
  modifier?: string,
  inline?: boolean,
  closeModal?: (...args: Array<any>) => any,
  closeable?: boolean
};

export default class Modal extends Component<Props> {
  componentDidMount() {
    if (!this.props.inline) {
      document.body.classList.add('no-scroll');
    }
  }

  componentWillUnmount() {
    if (!this.props.inline) {
      document.body.classList.remove('no-scroll');
    }
  }

  render() {
    const test = process.env.NODE_ENV === 'test';
    const { inline, children, modifier, closeModal, closeable } = this.props;
    if (inline || (test && children)) {
      return (
        <div className="c-modal__wrapper c-modal__inline">
          <div className="c-modal__container">{children}</div>
        </div>
      );
    }
    if (children) {
      return (
        <Portal
          node={
            typeof document !== 'undefined' &&
            (document.getElementById('portal') ||
              document.getElementById('content'))
          }
        >
          <div className={`c-modal c-modal--${modifier}`}>
            <div className="c-modal__wrapper">
              <div
                className={
                  !closeable ? `c-modal__container` : 'c-modal__container--full'
                }
              >
                {closeable && (
                  <div onClick={closeModal} className="close-icon">
                    {' '}
                    <img alt="close-icon" src={closeIcon} />
                  </div>
                )}
                {children}
              </div>
            </div>
          </div>
        </Portal>
      );
    }
    return null;
  }
}

Modal.defaultProps = {
  children: '',
  modifier: 'wide',
  inline: false,
  closeModal: () => {},
  closeable: false
};
